import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

import { subscriptionStepOuterElementCss } from '#/components/pages/subscription-v2/components/subscription-step-outer-element-style.ts'
import { SubscriptionV2Header } from '#/components/pages/subscription-v2/components/subscription-v2-header.tsx'
import { SubscriptionPageV2 } from '#/components/pages/subscription-v2/subscription-v2-page.tsx'
import { EndorsementExclusionPage } from '#/modules/endorsement/front-office/endorsement-exclusion-page/endorsement-exclusion-page.tsx'

const exclusionSearchSchema = type({
  'description?': 'string | undefined',
})

export const Route = createFileRoute('/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/exclusion')({
  validateSearch: exclusionSearchSchema,
  component: function Component() {
    const { subscriptionId } = Route.useParams()
    const { description } = Route.useSearch()

    return (
      <SubscriptionPageV2>
        <div css={subscriptionStepOuterElementCss}>
          <SubscriptionV2Header compact />
          <EndorsementExclusionPage subscriptionId={subscriptionId} description={description} />
        </div>
      </SubscriptionPageV2>
    )
  },
})
